import root from 'window-or-global';

export default function () {
  /**
   * Enum for URLs for the API endpoints.
   */
  let appContext = '';
  if (root.appContext && root.appContext !== '/') {
    appContext = root.appContext; //eslint-disable-line
  }

  if (!root.location.origin) {
    const port = root.location.port ? `:${root.location.port}` : '';
    root.location.origin = `${root.location.protocol}//${root.location.hostname}${port}`;
  }

  const origin =
    root.apiHost && root.apiHost.indexOf('undefined')
      ? root.apiHost
      : root.location.origin + appContext;

  const URL = {
    INVITE: {
      GETINVITES: `${origin}/api/invite`,
      SENDINVITE: `${origin}/api/sendInvite`,
    },

    REDEEM: {
      VALIDATE: `${origin}/ajax/redemption/validate-redemption-code`,
      SUBMIT: `${origin}/ajax/redemption/submit-redemption-code`,
      CLEARENTITLEMENTS: `${origin}/api/redeem/clear`,
    },

    POSA: {
      GET_CMS_CONTENT(locale) {
        return `${origin}/${locale}/api/posa/content`;
      },
      GET_CARD_STATUS(locale) {
        return `${origin}/${locale}/api/posa/code/status`;
      },
      REDEEM_CARD(locale) {
        return `${origin}/${locale}/api/posa/code/redeem`;
      },
    },
  };

  return URL;
}
